// Firestore collection schemas — REQUIREMENTS.md §5.
//
// All seven collections are defined here, including the four not used until
// later phases. Writing them together is what surfaced the P-Card/CSIU
// confirmation contradiction; keeping them together keeps the model honest.

export * from './common.js'
export * from './user.js'
export * from './budgetCode.js'
export * from './transaction.js'
export * from './receipt.js'
export * from './reconciliation.js'
export * from './csiuImport.js'
export * from './problemReport.js'

/** Firestore collection names, in one place so no string is retyped. */
export const COLLECTIONS = {
  users: 'users',
  budgetCodes: 'budgetCodes',
  transactions: 'transactions',
  receipts: 'receipts',
  reconciliationPeriods: 'reconciliationPeriods',
  creditCardStatements: 'creditCardStatements',
  csiuImports: 'csiuImports',
  problemReports: 'problemReports',
  /**
   * One tiny document per deleted receipt, written in the same batch as the
   * delete.
   *
   * It exists because the extraction function creates a receipt document when
   * none is there — the Storage trigger can beat the client's own write, and
   * that case is why provenance is written at all. Absence alone cannot tell
   * "the client's write has not landed yet" from "this receipt was deleted
   * while it was being read", and guessing from whether the file is still
   * there makes the answer depend on the order the delete happens to do its
   * two steps in. A marker makes it a fact: a deleted receipt is never
   * recreated by a reading that was already in flight.
   */
  deletedReceipts: 'deletedReceipts',
} as const

export type CollectionName = (typeof COLLECTIONS)[keyof typeof COLLECTIONS]
